export enum DelegationsRoute {
  DELEGATIONS_LIST = '/delegations',
  ADD_DELEGATION = '/delegations/add',
  DELEGATION_CARD = '/delegations/:uuid',
  EDIT_DELEGATION = '/delegations/:uuid/edit',
}
